import type { PartSvgProps } from './types'

export default function GenericPartSvg ({
  fill = 'var(--gs-part-fill,   #2A2A3A)',
  stroke = 'var(--gs-part-stroke, #5A6A7A)',
  accent = 'var(--gs-part-accent, #E85D04)',
  width = 100,
  height = 80
}: PartSvgProps) {
  return (
    <svg viewBox="0 0 100 80" width={width} height={height} fill="none"
         xmlns="http://www.w3.org/2000/svg">
      {/* Rounded rectangle housing */}
      <rect x="8" y="8" width="84" height="64" rx="10"
            fill={fill} stroke={stroke} strokeWidth="1.5" />
      {/* Corner accents */}
      <rect x="8" y="8" width="18" height="18" rx="10"
            fill="none" stroke={accent} strokeWidth="1" />
      <rect x="74" y="8" width="18" height="18" rx="10"
            fill="none" stroke={accent} strokeWidth="1" />
      {/* Question mark */}
      <text x="50" y="50" fontSize="28" fontWeight="700"
            textAnchor="middle" fill={accent} stroke="none"
            fontFamily="ui-monospace, monospace">?</text>
    </svg>
  )
}
